import React from 'react'

import { USPType } from '@application/Types/ComponentTypes'

import { Image, Item, Row, Title, Wrapper } from './USP.styled'

export const USP = ({ items }: USPType): JSX.Element => {
    return (
        <Wrapper>
            <Row>
                {items.map((item) => (
                    <Item key={`usp-item-${item.title}`}>
                        {item?.icon && <Image image={item.icon} width={20} height={20} />}
                        <Title>{item.title}</Title>
                    </Item>
                ))}
            </Row>
        </Wrapper>
    )
}
